export default {
  name: 'greatboss',
  env: 'devGreatboss',
  baseURL: `http://dev.greatboss.com`,
  wxMpRegisterUrlBase: `https://m.greatboss.com`,
}
